import React, {useContext} from 'react';
import  { styled } from 'styled-components';
import { ContextToggle } from '../context/ContextToggle';


import {ReactComponent as IconMenuBar} from '../assets/icons/iconmonstr-menu-drop-down-lined.svg';

const Btn = styled.button`

display: block;
width: 3.12rem;
height: 3.12rem;
line-height: 3.12rem;
text-align: center;
border: none;
background-color: #EA9D0E;
color: #fff;
display: flex;
align-items: center;
justify-content: center;
border-radius: 0.31rem;
cursor: pointer;

@media(max-width: 60rem){
    width: 2.5rem;
    height: 2.5rem,;
    line-height: 2.5rem;
}
`

const Icono = styled(IconMenuBar)`
width: 50%;
height: auto;
fill: #fff;
`

const BtnNavbar = () => {

    const {handleShow} = useContext(ContextToggle);
    return ( <Btn onClick={handleShow}><Icono></Icono></Btn> );
}
 
export default BtnNavbar;